import { createAction } from '@reduxjs/toolkit';

export const headerUpdateId = createAction('emailsHeader/updateId');
export const headerUpdateIsActive = createAction('emailsHeader/updateIsActive');

export const headerStore = createAction('emailsHeader/store');
export const headerClear = createAction('emailsHeader/clear');

export const headerUpdateRequest = createAction('emailsHeader/updateRequest');
export const headerUpdateError = createAction('emailsHeader/updateError');
export const headerUpdateStore = createAction('emailsHeader/updateStore');

export const headerUpdateImage = createAction('emailsHeader/updateImage');
export const headerUpdateImageSize = createAction('emailsHeader/updateImageSize');
export const headerUpdateImageShape = createAction('emailsHeader/updateImageShape');

export const headerUpdateLink = createAction('emailsHeader/updateLink');
export const headerUpdateName = createAction('emailsHeader/updateName');
export const headerUpdateNameSize = createAction('emailsHeader/updateNameSize');
export const headerUpdateView = createAction('emailsHeader/updateView');
